import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'includeZero',
  standalone: false,
})
export class IncludeZeroPipe implements PipeTransform {
  transform(value?: number | null): boolean {
    if (value === 0) return true;
    return !!value;
  }
}
